/**
 * Nueva función: Actualiza el input oculto (#chillerselected) y luego llama a la actualización de precios de protección.
 * @param {HTMLInputElement} radioInput - El radio button del Chiller que fue seleccionado o que está por defecto.
 */
function updateChillerSelectionAndPrice(radioInput) {
    const stateInput = document.getElementById("chillerselected");
    if (stateInput && radioInput) {
        // 1. Actualizar el input oculto con el valor seleccionado
        stateInput.value = radioInput.value.trim();
        // console.log(`[CHILLER STATE] Valor actualizado: ${stateInput.value.trim()}`);
    }

    // 2. Ejecutar la lógica de precios de protección
    updateProtectionPrice();
}

// --- HELPER: Format price for CA market ---
function formatPriceForMarket(price) {
    if (!price) return price;
    var isCA = window.Shopify && window.Shopify.country && window.Shopify.country === 'CA';
    if (!isCA) {
        isCA = document.documentElement.lang && document.documentElement.lang.indexOf('ca') !== -1;
    }
    if (!isCA) {
        isCA = window.location.pathname.indexOf('/en-ca') !== -1;
    }
    if (isCA) {
        // Idempotent: if the value is already formatted (e.g. the Liquid-rendered
        // "810 $CA" used as a fallback when data-*-price attrs are missing), return it
        // as-is. Otherwise replace('$','') would strip the $ out of "$CA" and re-append
        // " $CA", mutating the text on every pass — which makes updateChillerPrices'
        // guard never match, so it writes endlessly and the subtree MutationObserver
        // re-fires forever → OOM crash on CA. See chiller price loop fix.
        if (price.indexOf('$CA') !== -1) return price;
        return price.replace('$', '') + ' $CA';
    }
    return price;
}

// --- FUNCIÓN EXISTENTE: ACTUALIZA PRECIOS DE CHILLER ---
function updateChillerPrices(isWifiActive) {
    // ... Tu código existente para updateChillerPrices ...
    const chillerInputs = document.querySelectorAll('input[name^="Water Chiller-1"]');
    if (chillerInputs.length === 0) {
        return;
    }

    chillerInputs.forEach(input => {
        const label = document.querySelector(`label[for="${input.id}"]`);
        if (!label) {
            return;
        }

        const priceElement = label.querySelector('.option-label-details-price-new');
        const oldPriceElement = label.querySelector('.option-label-details-price-old');
        if (!priceElement) {
            return;
        }
        const basePrice = input.dataset.nowifiPrice;
        const wifiPrice = input.dataset.wifiPrice;

        let newPrice = '';

        if (isWifiActive && wifiPrice) {
            newPrice = wifiPrice;
        } else if (basePrice) {
            newPrice = basePrice;
        } else {
            newPrice = priceElement.textContent;
            console.warn(`[PRECIOS] ⚠️ Advertencia: Faltan data-attributes (wifi/base) en el input ID: ${input.id}. Usando precio actual.`);
        }

        newPrice = formatPriceForMarket(newPrice);

        if (newPrice && priceElement.textContent.trim() !== newPrice.trim()) {
            priceElement.textContent = newPrice;
        }

        // Actualizar el precio tachado (old price).
        if (oldPriceElement) {
            const baseOldPrice = input.dataset.nowifiPriceOld;
            const wifiOldPrice = input.dataset.wifiPriceOld;
            let newOldPrice = '';
            if (isWifiActive && wifiOldPrice) {
                newOldPrice = wifiOldPrice;
            } else if (baseOldPrice) {
                newOldPrice = baseOldPrice;
            }
            newOldPrice = formatPriceForMarket(newOldPrice);
            if (newOldPrice && oldPriceElement.textContent.trim() !== newOldPrice.trim()) {
                oldPriceElement.textContent = newOldPrice;
            }
        }
    });
    // ... Fin de tu código existente ...
}


// --- FUNCIÓN EXISTENTE: LÓGICA DE PROTECCIÓN (Asegúrate de que baseProtectionText tiene el espacio) ---
function updateProtectionPrice() {
    const PROTECTION_FIELDSET_CLASS = ".custom_chooseprotection";
    const STATE_INPUT_ID = "#chillerselected";
    const baseProtectionText = "5- Year"; // ¡IMPORTANTE! Debe coincidir con el valor HTML

    // ... Tu priceMap existente ...
    const priceMap = {
        "1/3HP": " +$299",
        "1/2HP": " +$399",
        "1HP": " +$499",
        "No Chiller": " +$299"
    };

    const stateInput = document.querySelector(STATE_INPUT_ID);
    let selectedChillerValue = stateInput ? stateInput.value : null;

    if (!selectedChillerValue) return;

    // Obtener elementos de la protección de forma robusta
    const currentProtectionFieldset = document.querySelector(PROTECTION_FIELDSET_CLASS);
    const protectionInput = currentProtectionFieldset ? currentProtectionFieldset.querySelector('input[value*="5- Year"]') : null;
    if (!protectionInput) return;

    const protection5YearLabel = protectionInput.nextElementSibling;
    const protection5YearVariantName = protection5YearLabel ? protection5YearLabel.querySelector('.variant-name') : null;
    if (!protection5YearVariantName) return;

    let priceSuffix = "";

    // Lógica para determinar el sufijo de precio
    if (selectedChillerValue === "No Chiller") {
        priceSuffix = priceMap["No Chiller"];
    } else if (selectedChillerValue.includes("1/3HP")) {
        priceSuffix = priceMap["1/3HP"];
    } else if (selectedChillerValue.includes("1/2HP")) {
        priceSuffix = priceMap["1/2HP"];
    } else if (selectedChillerValue.includes("1HP")) {
        priceSuffix = priceMap["1HP"];
    } else {
        priceSuffix = "";
    }

    const newVisibleText = baseProtectionText + priceSuffix;

    // Aplicar SOLO el cambio de texto visible
    if (protection5YearVariantName.textContent.trim() !== newVisibleText.trim()) {
        protection5YearVariantName.textContent = newVisibleText;
    }
}
// ---------------------------------------------------------------------

/**
 * Función que maneja la lógica de click y estado del switch.
 * Se necesita actualizar la selección del chiller cuando el switch de WiFi cambia.
 */
function handleSwitchLogic(switchButton, wifiInput, withoutWifiInput, switchContainer) {
    // ... Tu código existente de handleSwitchClick ...
    function handleSwitchClick(event) {
        const clickedElement = event.target.closest('#my-switch, .switch-label');
        if (!clickedElement) return;

        if (event.target.closest('.tooltip-icon')) {
            return;
        }

        event.stopPropagation();
        event.preventDefault();

        let isWifiChecked = switchContainer.classList.contains('is-active');

        switchContainer.classList.toggle('debug-clicked');

        // --- LÓGICA DE CAMBIO DE ESTADO ---
        const chillerFieldset = document.querySelector('.custom_waterchiller');
        const firstYesRadio = chillerFieldset.querySelector('#option-yes input[type="radio"]:checked') || chillerFieldset.querySelector('#option-yes input[type="radio"]');

        if (isWifiChecked) {
            // CAMBIANDO A SIN WIFI (OFF)
            if (withoutWifiInput.checked !== true) {
                withoutWifiInput.checked = true;
                withoutWifiInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
            switchContainer.classList.remove('is-active');
            updateChillerPrices(false);

            // ⭐ AÑADIDO: Vuelve a aplicar el precio de protección del Chiller seleccionado actualmente
            if(firstYesRadio) updateChillerSelectionAndPrice(firstYesRadio);

        } else {
            // CAMBIANDO A CON WIFI (ON)
            if (wifiInput.checked !== true) {
                wifiInput.checked = true;
                wifiInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
            switchContainer.classList.add('is-active');
            updateChillerPrices(true);

            // ⭐ AÑADIDO: Vuelve a aplicar el precio de protección del Chiller seleccionado actualmente
            if(firstYesRadio) updateChillerSelectionAndPrice(firstYesRadio);
        }
    }

    // --- Lógica de Inicialización ---

    if (switchContainer.hasAttribute('data-delegated-listener')) {
        let isCheckedInitial = wifiInput.checked;
        switchContainer.classList.toggle('is-active', isCheckedInitial);
        updateChillerPrices(isCheckedInitial);

        // ⭐ LLAMADA DE INICIALIZACIÓN: Asegurar que la protección se aplica
        updateProtectionPrice();

        return;
    }

    switchContainer.addEventListener('click', handleSwitchClick);
    switchContainer.setAttribute('data-delegated-listener', 'true');

    let isCheckedInitial = wifiInput.checked;
    switchContainer.classList.toggle('is-active', isCheckedInitial);
    updateChillerPrices(isCheckedInitial);

    // ⭐ LLAMADA DE INICIALIZACIÓN: Asegurar que la protección se aplica
    updateProtectionPrice();
}

// ... Tu función initializeWifiSwitchController existente ...
function initializeWifiSwitchController() {
    const productInfoContainer = document.querySelector('.product__info-container');
    if (!productInfoContainer) {
        // console.error('[INICIO] 🛑 Contenedor ".product__info-container" no encontrado.');
        return;
    }

    function findAndApplyLogic() {
        const switchButton = document.getElementById('my-switch');
        const switchContainer = switchButton ? switchButton.closest('.switch-container') : null;
        const wifiInput = document.querySelector('input[type="radio"][value^="Yes WiFi"], input[type="radio"][value^="Yes App Controlled"]');
        const withoutWifiInput = document.querySelector('input[type="radio"][value^="No WiFi"], input[type="radio"][value^="No App Controlled"]');

        if (!switchButton || !switchContainer || !wifiInput || !withoutWifiInput) {
            // console.warn('[INICIO] ⚠️ Elementos clave (switch/inputs Yes/No) no encontrados. Reintentando en carga dinámica.');
            return;
        }
        handleSwitchLogic(switchButton, wifiInput, withoutWifiInput, switchContainer);

        // Llamada adicional de inicialización por si el handleSwitchLogic no cubrió el caso.
        updateProtectionPrice();
    }

    findAndApplyLogic();

    const observer = new MutationObserver((mutationsList, observer) => {
        findAndApplyLogic();
    });

    observer.observe(productInfoContainer, {
        childList: true,
        subtree: true
    });
    document.addEventListener('shopify:section:load', findAndApplyLogic);

    // ⭐ LLAMADA DE INICIALIZACIÓN: Asegurar que la protección se aplica después de la carga inicial
    updateProtectionPrice();
}

document.addEventListener('DOMContentLoaded', initializeWifiSwitchController);
// observeChillerSelection(); // Comentado si no existe, si existe, déjala.

// --- 🎯 LÓGICA DE INICIALIZACIÓN Y LISTENERS DE CHILLER (AGREGAR ESTO) ---
document.addEventListener('DOMContentLoaded', function() {
    const chillerFieldset = document.querySelector('.custom_waterchiller');

    // 1. Manejar Clics en los radios de Chiller (1/3HP, 1/2HP, 1HP)
    if (chillerFieldset) {
        chillerFieldset.querySelectorAll('input[name^="Water Chiller-1"]').forEach(radio => {
            radio.addEventListener('change', function() {
                updateChillerSelectionAndPrice(this);
            });
        });

        // 2. Manejar Clics en los botones NO y YES (que activan radios ocultos/internos)
        const noButton = document.getElementById("option-no-button");
        const yesButton = document.getElementById("option-yes-button");

        if (noButton) {
            noButton.addEventListener("click", () => {
                const noRadio = chillerFieldset.querySelector('input[value="No Chiller"]');
                if (noRadio) {
                    // Esperar a que el código del otro script haga el `noRadio.checked = true`
                    setTimeout(() => updateChillerSelectionAndPrice(noRadio), 0);
                }
            });
        }

        if (yesButton) {
            yesButton.addEventListener("click", () => {
                // El código de base selecciona el primer radio de 'Yes'
                const firstYesRadio = chillerFieldset.querySelector('#option-yes input[type="radio"]');
                if (firstYesRadio) {
                    // Esperar a que el código del otro script haga la selección
                    setTimeout(() => updateChillerSelectionAndPrice(firstYesRadio), 0);
                }
            });
        }

        // 3. 🎯 LLAMADA FINAL DE INICIALIZACIÓN
        const initialSelectedChiller = chillerFieldset.querySelector('input[name^="Water Chiller-1"]:checked');
        if (initialSelectedChiller) {
            updateChillerSelectionAndPrice(initialSelectedChiller);
        } else {
             // Si no hay un 'checked' por defecto (raro), forzar una actualización simple.
             updateProtectionPrice();
        }
    }
});
